import { gql } from '@apollo/client';
import { CONTENT_BLOCK } from '../content';
import { COLUMNS_BLOCK } from '../columns';
import { SLIDER_WITH_BLOCKS } from '../sliderWithBlocks';
import { BLOCK_SETTINGS_FIELD, MEDIA_FIELD } from '../../fields';
import { SERVICES_SCROLLER_BLOCK } from '../servicesScroller';

export const BACKGROUND_WITH_BLOCK = gql`
  fragment BackgroundWithBlockFragment on BackgroundWithBlock {
    backgroundColor
    containerWidth
    hasBackgroundGridImage
    backgroundWithBlocks: blocks {
      ...ContentBlockFragment
      ...ColumnsBlockFragment
      ...SliderWithBlocksFragment
      ...ServicesScrollerBlockFragment
    }
    showBackgroundImage
    backgroundImage {
      ...MediaFieldFragment
    }
    id
    blockName
    blockType
    blockSettings {
      ...BlockSettingsFieldFragment
    }
  }
  ${CONTENT_BLOCK}
  ${COLUMNS_BLOCK}
  ${SLIDER_WITH_BLOCKS}
  ${BLOCK_SETTINGS_FIELD}
  ${BLOCK_SETTINGS_FIELD}
  ${SERVICES_SCROLLER_BLOCK}
  ${MEDIA_FIELD}
`;
